import Crud from '../components/ClassRecipe/Crud'

let routes = {
    path: '/classRecipe',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/classRecipe',
            component: Crud,
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/classRecipe.js